export const BUTTON_WIDTH_DEFAULT = 59;
